export default {
    meta: {
        title: '拓店宝-评分解读'
    }
};
